module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1